import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private redirectUrl: string | null = null;
  private jwtHelper: JwtHelperService = new JwtHelperService();
  private permissions: string[] = [];

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  getRedirectUrl(): string | null {
    return this.redirectUrl;
  }

  clearRedirectUrl(): void {
    this.redirectUrl = null;
  }

  setPermissions(permissions: string[]): void {
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }

  hasPermission(permission: string): boolean {
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      this.permissions = JSON.parse(storedPermissions);
    }

    return this.permissions.includes(permission);
  }
  getStoredPermissions(): string[] {
    return this.permissions;
  }

  decodeToken(token: string): any {
    return this.jwtHelper.decodeToken(token);
  }

  isTokenExpired(token: string): boolean {
    return this.jwtHelper.isTokenExpired(token);
  }
}
